export type DevelopmentStepModelFR = {
  description: string;
  date: string;
  annee: number;
  trimestre: number;
  labelDate: string;
};

export type DevelopmentStepModel = {
  description: string;
  date: string;
  year: number;
  trimester: number;
  labelDate: string;
};

export const translateDevelopmentStep = (ds: DevelopmentStepModelFR): DevelopmentStepModel => {
  return {
    description: ds.description,
    date: ds.date,
    year: ds.annee,
    trimester: ds.trimestre,
    labelDate: ds.labelDate,
  };
};

export const translateDevelopmentStepArray = (dsA: DevelopmentStepModelFR[]): DevelopmentStepModel[] => {
  return dsA.map(e => translateDevelopmentStep(e));
};
